import { useEffect, useState } from "react";
import {
  getTestimonials,
  saveTestimonial,
  deleteTestimonial,
} from "@/lib/cloudApi";
import { toast } from "sonner";
import { Plus, Save, X, Trash2 } from "lucide-react";

const empty = { quote: "", name: "", place: "", order: 0 };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = async () => {
    const data = await getTestimonials();
    setItems(Array.isArray(data) ? data : []);
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      const p = { ...editing, order: Number(editing.order) || 0 };
      await saveTestimonial(p);
      toast.success("Saved"); setEditing(null); load();
    } catch (e) { toast.error(e?.message || "Failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete?")) return;
    await deleteTestimonial(id); toast.success("Deleted"); load();
  };

  const input = "w-full bg-transparent border-b border-[#C99A45]/30 focus:border-[#C99A45] outline-none py-2 text-sm";

  return (
    <div className="p-10" data-testid="admin-testimonials">
      <div className="flex items-center justify-between">
        <div>
          <div className="eyebrow text-[#C99A45]">Manage</div>
          <h1 className="font-serif-display text-5xl mt-3">Testimonials</h1>
        </div>
        <button onClick={() => setEditing({ ...empty })} className="btn-gold" data-testid="add-testimonial"><Plus size={14} /> Add</button>
      </div>
      <div className="gold-divider my-6"></div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-8">
        {items.map((t) => (
          <div key={t.id} className="border border-[#C99A45]/20 p-5" data-testid={`testimonial-${t.id}`}>
            <p className="font-serif-display italic text-lg text-[#F7F1E8]/90">"{t.quote}"</p>
            <div className="eyebrow text-[10px] text-[#C99A45]/80 mt-3">{t.name} · {t.place}</div>
            <div className="flex gap-3 mt-3 text-xs">
              <button onClick={() => setEditing(t)} className="text-[#C99A45] hover:underline">Edit</button>
              <button onClick={() => del(t.id)} className="text-[#E52717] hover:underline">Delete</button>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-6" onClick={() => setEditing(null)}>
          <form onSubmit={save} onClick={(e) => e.stopPropagation()} className="bg-[#0a0a0a] border border-[#C99A45]/30 p-8 w-full max-w-lg space-y-4" data-testid="testimonial-modal">
            <div className="flex items-center justify-between">
              <h2 className="font-serif-display text-2xl">{editing.id ? "Edit" : "Add"} Testimonial</h2>
              <button type="button" onClick={() => setEditing(null)}><X size={18} /></button>
            </div>
            <div>
              <label className="eyebrow text-[10px] text-[#C99A45]/80">Quote *</label>
              <textarea required rows={4} value={editing.quote} onChange={(e) => setEditing({ ...editing, quote: e.target.value })} className={`${input} resize-none`} />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="eyebrow text-[10px] text-[#C99A45]/80">Couple Name *</label>
                <input required value={editing.name} onChange={(e) => setEditing({ ...editing, name: e.target.value })} className={input} />
              </div>
              <div>
                <label className="eyebrow text-[10px] text-[#C99A45]/80">Place</label>
                <input value={editing.place} onChange={(e) => setEditing({ ...editing, place: e.target.value })} className={input} />
              </div>
            </div>
            <div>
              <label className="eyebrow text-[10px] text-[#C99A45]/80">Order</label>
              <input type="number" value={editing.order} onChange={(e) => setEditing({ ...editing, order: e.target.value })} className={input} />
            </div>
            <div className="flex gap-3 pt-2">
              <button type="submit" className="btn-gold"><Save size={12} /> Save</button>
              <button type="button" onClick={() => setEditing(null)} className="btn-outline-gold">Cancel</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
